import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import Page, { usePage } from 'contexts/page'
import { useNavigate, useLocation } from 'react-router-dom'
import paths from 'app/paths'
import { anonymizePath } from 'utilities/url'
import Message from 'components/message'
import { Columns, FlexChild } from 'components/flex'
import { Title } from 'components/typography/heading'
import { ButtonColumn } from './s'
import { Button, Plain } from 'components/button'

const NotFoundPage = () => {
    const { formatMessage } = useIntl()
    const { title } = usePage()

    const navigate = useNavigate()

    return (
        <>
            <Title>{title}</Title>
            <Message
                type="warning"
                message={formatMessage({
                    id: 'page_not_found_message',
                    defaultMessage: 'This page doesn’t exist. We did a wrong, sorry!'
                })} />
            <Columns>
                <ButtonColumn>
                    <Button
                        className="constructive"
                        onClick={() => navigate(-1)}>
                        <FormattedMessage
                            id="action_go_back"
                            defaultMessage="Go back" />
                    </Button>
                </ButtonColumn>
                <FlexChild>
                    <Plain onClick={() => navigate(paths.root)}>
                        <FormattedMessage
                            id="action_go_dashboard"
                            defaultMessage="Go to the dashboard" />
                    </Plain>
                </FlexChild>
            </Columns>
        </>
    )
}

export default props => {
    const { pathname } = useLocation()

    return (
        <Page
            view={{
                name: 'page_not_found',
                path: anonymizePath(pathname)
            }}
            title={{
                id: 'page_not_found_title',
                defaultMessage: 'Page not found'
            }}>
            <NotFoundPage {...props} />
        </Page>
    )
}